// "Production" enabled environment

export const environment = {
    production: true,
    hmr: false
};



// WEBPACK FOOTER //
// ./src/environments/environment.ts